



















































































































































































































































import moment from 'moment'
import { BrandSkuGetters } from '@/store/brand-sku/getters'
import { ChainStoreGetters } from '@/store/chain-store/getters'
import { ChannelGetters } from '@/store/channel/getters'
import {
  defineComponent,
  onBeforeMount,
  ref,
  toRefs,
  watch,
} from '@vue/composition-api'
import {
  ChannelEntity,
  SpecialOfferEntity,
  UpdateSpecialOfferDto,
} from '../../../../api/@types'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { BrandSkuActions } from '@/store/brand-sku/actions'
import { ChannelActions } from '@/store/channel/actions'
import { ChainStoreActions } from '@/store/chain-store/actions'
import { useFormRef } from '@/composable/common/useFormRef'
import { CategoryGetters } from '@/store/category/getters'
import { CategoryActions } from '@/store/category/actions'
import TagCreator from '@/components/organisms/questionnaire/TagCreator.vue'

type FieldType = {
  nameAdmin: string
  channels: ChannelEntity[]
  chainStoreNames: string[]
  chainStoreNameInputs: { name: string }[]
  parentCategories: number[]
  childCategories: number[]
  itemNames: string[]
  itemNameSeconds: string[]
  itemNameInputs: { name: string }[]
  itemNameInputSeconds: { name: string }[]
  canFreeChainStoreName: boolean
  canFreeItemName: boolean
  canFreeItemNameSecond: boolean
  needsLeaderCheck: boolean
}

type Props = {
  specialOffer: SpecialOfferEntity
}

export default defineComponent({
  name: 'SpecialOffer',
  components: { TagCreator },
  props: {
    specialOffer: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const { specialOffer: s } = toRefs(props)

    const { getParentCategories, getChildCategories } = useActions<
      CategoryActions
    >('category', ['getParentCategories', 'getChildCategories'])
    const { getBrandSkus } = useActions<BrandSkuActions>('brandSku', [
      'getBrandSkus',
    ])
    const { getChannels } = useActions<ChannelActions>('channel', [
      'getChannels',
    ])
    const { getChainStores } = useActions<ChainStoreActions>('chainStore', [
      'getChainStores',
    ])

    const { channels } = useGetters<ChannelGetters>('channel', ['channels'])
    const { chainStores } = useGetters<ChainStoreGetters>('chainStore', [
      'chainStores',
    ])
    const { parents, children } = useGetters<CategoryGetters>('category', [
      'parents',
      'children',
    ])
    const { brandSkus } = useGetters<BrandSkuGetters>('brandSku', ['brandSkus'])

    const input = ref<FieldType>({
      nameAdmin: s.value.nameAdmin || '',
      channels: [],
      chainStoreNames: s.value.chainStoreNames || [],
      chainStoreNameInputs: (s.value.chainStoreNames || []).map(i => ({
        name: i,
      })),
      parentCategories: [],
      childCategories: s.value.pobCategoryIds || [],
      itemNames: s.value.itemNames || [],
      itemNameSeconds: s.value.itemNameSeconds || [],
      itemNameInputs: (s.value.itemNames || []).map(i => ({ name: i })),
      itemNameInputSeconds: (s.value.itemNameSeconds || []).map(i => ({
        name: i,
      })),
      canFreeChainStoreName: s.value.canFreeChainStoreName ?? false,
      canFreeItemName: s.value.canFreeItemName ?? false,
      canFreeItemNameSecond: s.value.canFreeItemNameSecond ?? false,
      needsLeaderCheck: s.value.needsLeaderCheck ?? false,
    })
    watch(
      () => s.value.id,
      _ => {
        input.value = {
          nameAdmin: s.value.nameAdmin || '',
          channels: [],
          chainStoreNames: s.value.chainStoreNames || [],
          chainStoreNameInputs: (s.value.chainStoreNames || []).map(i => ({
            name: i,
          })),
          parentCategories: [],
          childCategories: s.value.pobCategoryIds || [],
          itemNames: s.value.itemNames || [],
          itemNameSeconds: s.value.itemNameSeconds || [],
          itemNameInputs: (s.value.itemNames || []).map(i => ({ name: i })),
          itemNameInputSeconds: (s.value.itemNameSeconds || []).map(i => ({
            name: i,
          })),
          canFreeChainStoreName: s.value.canFreeChainStoreName ?? false,
          canFreeItemName: s.value.canFreeItemName ?? false,
          canFreeItemNameSecond: s.value.canFreeItemNameSecond ?? false,
          needsLeaderCheck: s.value.needsLeaderCheck ?? false,
        }
      },
    )

    watch(
      () => input.value.parentCategories,
      val => {
        const ids = val.length > 0 ? val : undefined
        getChildCategories(ids)
      },
    )

    watch(
      () => input.value.childCategories,
      val => {
        const categories = val.length > 0 ? val : []
        getBrandSkus({ name: '', jicsfClassificationCds: categories })
      },
    )

    watch(
      () => input.value.channels,
      val => {
        const channelIds = val.length > 0 ? [...val.map(i => i.id)] : undefined
        getChainStores({ channelIds, limit: 1000 })
      },
    )

    const { form, validate } = useFormRef()

    const rules = [(v: any) => !!v || '必須項目です。']

    const save = () => {
      if (!validate()) {
        return
      }

      const body: Partial<UpdateSpecialOfferDto> = {
        ...input.value,
        chainStoreNames: input.value.chainStoreNames || [],
        pobCategoryIds: input.value.childCategories,
        itemNames: input.value.itemNames || [],
        itemNameSeconds: input.value.itemNameSeconds || [],
      }
      context.emit('submit', body)
    }

    const cancel = () => {
      context.emit('cancel')
    }

    onBeforeMount(() => {
      Promise.all([
        getParentCategories(),
        getChildCategories(undefined),
        getChannels(),
        getChainStores({ limit: 1000 }),
        getBrandSkus({
          name: '',
          jicsfClassificationCds: s.value.pobCategoryIds || [],
        }),
      ])
    })

    const addItemNameChoice = (inputText: string) => {
      const itemNameInputs = inputText
        .trim()
        .split('\n')
        .flatMap(line => line.split('\t'))
        .map(choice => choice.trim())
        .map(name => ({ name, isLast: false }))
      input.value.itemNameInputs.push(...itemNameInputs)
      input.value.itemNames = input.value.itemNameInputs.map(tc => tc.name)
    }
    const addItemNameChoiceSecond = (inputText: string) => {
      const itemNameInputSeconds = inputText
        .trim()
        .split('\n')
        .flatMap(line => line.split('\t'))
        .map(choice => choice.trim())
        .map(name => ({ name, isLast: false }))
      input.value.itemNameInputSeconds.push(...itemNameInputSeconds)
      input.value.itemNameSeconds = input.value.itemNameInputSeconds.map(
        tc => tc.name,
      )
    }

    const removeItemNameChoice = (index: number) => {
      input.value.itemNameInputs = input.value.itemNameInputs.filter(
        (_, i) => i !== index,
      )
      input.value.itemNames = input.value.itemNameInputs.map(tc => tc.name)
    }
    const removeItemNameChoiceSecond = (index: number) => {
      input.value.itemNameInputSeconds = input.value.itemNameInputSeconds.filter(
        (_, i) => i !== index,
      )
      input.value.itemNameSeconds = input.value.itemNameInputSeconds.map(
        tc => tc.name,
      )
    }

    const removeItemNameAll = () => {
      input.value.itemNameInputs = []
      input.value.itemNames = []
    }

    const removeItemNameAllSecond = () => {
      input.value.itemNameInputSeconds = []
      input.value.itemNameSeconds = []
    }

    const editItemNameChoice = (data: { index: number; name: string }) => {
      input.value.itemNameInputs = input.value.itemNameInputs.map(
        (itemNameInput, i) => {
          if (i === data.index) {
            return { ...itemNameInput, name: data.name }
          }
          return itemNameInput
        },
      )
      input.value.itemNames = input.value.itemNameInputs.map(i => i.name)
    }
    const editItemNameChoiceSecond = (data: {
      index: number
      name: string
    }) => {
      input.value.itemNameInputSeconds = input.value.itemNameInputSeconds.map(
        (itemNameInput, i) => {
          if (i === data.index) {
            return { ...itemNameInput, name: data.name }
          }
          return itemNameInput
        },
      )
      input.value.itemNameSeconds = input.value.itemNameInputSeconds.map(
        i => i.name,
      )
    }

    watch(
      () => input.value.itemNames,
      val => {
        input.value.itemNameInputs = val.map(tc => ({ name: tc }))
      },
    )

    const addChainStoreNameChoice = (inputText: string) => {
      const chainStoreNameInputs = inputText
        .trim()
        .split('\n')
        .flatMap(line => line.split('\t'))
        .map(choice => choice.trim())
        .map(name => ({ name, isLast: false }))
      input.value.chainStoreNameInputs.push(...chainStoreNameInputs)
      input.value.chainStoreNames = input.value.chainStoreNameInputs.map(
        tc => tc.name,
      )
    }

    const removeChainStoreNameChoice = (index: number) => {
      input.value.chainStoreNameInputs = input.value.chainStoreNameInputs.filter(
        (_, i) => i !== index,
      )
      input.value.chainStoreNames = input.value.chainStoreNameInputs.map(
        tc => tc.name,
      )
    }

    const removeChainStoreNameAll = () => {
      input.value.chainStoreNameInputs = []
      input.value.chainStoreNames = []
    }

    const editChainStoreNameChoice = (data: {
      index: number
      name: string
    }) => {
      input.value.chainStoreNameInputs = input.value.chainStoreNameInputs.map(
        (chainStoreNameInput, i) => {
          if (i === data.index) {
            return { ...chainStoreNameInput, name: data.name }
          }
          return chainStoreNameInput
        },
      )
      input.value.chainStoreNames = input.value.chainStoreNameInputs.map(
        tc => tc.name,
      )
    }

    watch(
      () => input.value.chainStoreNames,
      val => {
        input.value.chainStoreNameInputs = val.map(cs => ({ name: cs }))
      },
    )

    return {
      moment,
      s,
      input,
      form,
      channels,
      chainStores,
      parents,
      children,
      brandSkus,
      rules,
      save,
      cancel,
      addItemNameChoice,
      addItemNameChoiceSecond,
      removeItemNameChoice,
      removeItemNameChoiceSecond,
      removeItemNameAll,
      removeItemNameAllSecond,
      editItemNameChoice,
      editItemNameChoiceSecond,
      addChainStoreNameChoice,
      removeChainStoreNameChoice,
      removeChainStoreNameAll,
      editChainStoreNameChoice,
    }
  },
})
